import { Link } from 'react-router-dom';
import { usePageMeta } from '../../hooks/usePageMeta';
import { MARKETING_CTA } from './marketingConfig';

interface MarketingContentPageProps {
  title: string;
  description: string;
  path: string;
  bullets: string[];
  comingSoon?: boolean;
}

export function MarketingContentPage({
  title,
  description,
  path,
  bullets,
  comingSoon,
}: MarketingContentPageProps) {
  usePageMeta({ title, description, path });

  return (
    <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 pt-14">
      <h1 className="text-4xl font-semibold tracking-tight">{title}</h1>
      <p className="mt-4 text-gray-300">{description}</p>

      <div className="mt-8 rounded-xl border border-surface-4 bg-surface-1 p-6">
        <ul className="space-y-3 text-sm text-gray-300">
          {bullets.map((point) => (
            <li key={point}>• {point}</li>
          ))}
        </ul>
      </div>

      {comingSoon && (
        <p className="mt-5 text-sm text-brand">
          This route is now provisioned and will expand with production content in upcoming releases.
        </p>
      )}

      <div className="mt-8 mb-10 flex gap-3 flex-wrap">
        <Link to={MARKETING_CTA.requestAccess.to} className="btn-primary">
          {MARKETING_CTA.requestAccess.label}
        </Link>
        <Link to="/login" className="btn-ghost border border-surface-4">
          Login
        </Link>
      </div>
    </div>
  );
}
